import {
  saveReferral,
  fetchReferral,
  deleteReferral,
  fetchReferralSyncRecords,
  apiFetchLabraReferralStatusHistory,
} from '../../../../oppsync/api/CoSell'
import { fetchAwsOpportunity } from '../../../../common/api/CoSell'
import { fetchPartnerObject } from '../../../../common/api'
import {
  ReferralFormSectionName,
  ReferralOppSections,
  PartialReferralObject,
  CustomerDetails,
  ProjectDetails,
  AwsDetails,
  LabraReferralStatusHistory,
  ReferralOppSectionFields,
  ProductListType,
  SaaSDocumentation,
  offerData,
} from './reducer'
import type { AppDispatch, RootState } from '../../../../store'
import { Referral, ReferralAPI, ReferralMetadata } from '../reducer.ts'
import type { PartnerCentralUsers } from '../../../../externalApps/modules/customForm/actions'
import { startLoading, stopLoading, LoadingTypes } from '@labrav/common'
import { errorLogger } from '../../../../common/utils/errorLogger.ts'
import { updateAppAlert } from '../../../../common/modules/appAlert/actions.ts'
import {
  RequestFailureMessage,
  cosellDefaultFieldsError,
} from '../../../../common/utils/messagesContants.ts'
import { getErrorMessages } from '../../../../common/utils/error.ts'
import { AxiosError, AxiosResponse } from 'axios'
import { autoSave } from '../../../../common/modules/autoSave/actions.ts'
import {
  APIReferralError,
  parseReferralAPIError,
  formatErrorMessagesForAlert,
  filterErrorsForNonExistentFormikFields,
  hasReferralErrorOnRequiredOnlyHiddenField,
} from '../../../../externalApps/api/errorHandlers.ts'
import { actionTypeWrapper } from '../../../../common/utils/actionTypeWrapper'
import { setIsShowRequiredFieldsOnly } from '../actions'
import {
  mapLeadApiToLead,
  getReferredBy,
  mapReferralApiToReferral,
  removeEmptyValues,
} from '../../../../common/utils/CoSellHelpers/helperFunctions.ts'
import { isEmpty } from 'lodash'
import { camelize } from 'casing'
import { PartnerType } from '../../../../common/modules/partner/action.ts'
import { ReferralMetadataType, ReferralUpdatedBy } from '../types.ts'
import { ActionType } from '../../../../externalApps/modules/referrals/actions.ts'
import { ReferralStage, SyncRecord } from '../../../components/CoSell/types.ts'
import {
  extractPartnerObjectSyncs,
  mapPartnerObjectSyncsToSyncRecords,
} from '../../../../common/utils/partnerObjectMapper'
import {
  PartialLeadObject,
  ReferralLeadSections,
} from '../LeadsReferralForm/types.ts'
import { CosellReferralType } from '../actions.ts'
import { CloudType } from '../../../../common/modules/types'
import {
  setAzureCreationData,
  setAzureDetails,
  setAzureFormFieldErrors,
  mapAzureApiToForm,
  submitAzureForm,
} from '../AzureReferralForm/actions.ts'
import {
  mapLeadApiToForm,
  setLeadCreationData,
  setLeadDetails,
  setLeadFormFieldErrors,
  submitLeadForm,
} from '../LeadsReferralForm/actions.ts'
export const REFERRAL_FORM_LOADING = 'REFERRAL_FORM'
import {
  capitalizeFirstLetter,
  getClaimsFromToken,
  getSecureKey,
} from '../../../../common/utils/helperFunctions.ts'
import { isHubSpotContext } from '../../../../common/utils/appContext.ts'
import { FormikErrors } from 'formik'
import {
  fetchPrivateOffersList,
  fetchPrivateOffersValidation,
  fetchProductsList,
} from '../../../api/index.ts'
import {
  saveReferral as saveSalesforceReferral,
  SaveReferralAPIParams,
  acceptReferral,
  rejectReferral,
  linkOpportunity,
} from '../../../api/CoSell/index.new.ts'
import { fetchReferral as fetchReferralAPI } from '../../../api/CoSell/index.new.ts'
import {
  fetchCrmObjectLinks,
  getRecordByRecordId,
} from '../../../../common/api/OpportunityDetails'
import {
  crmOpportunityToOption,
  type OpportunityOption,
} from '../../../components/CoSell/ReferralDetails/LinkOpportunity/linkOpportunity.utils'
import { canvasAuthService } from '../../../../common/services/CanvasAuthService'
import {
  trimReferralBusinessProblemForApi,
  trimReferralMarketingActivityFlag,
  trimReferralPostalCodeForApi,
  trimReferralStringField,
} from '../../../../common/utils/CoSellHelpers/referralSubmitStringUtils'
import {
  getHubspotCosellAccountIdFromPath,
  getHubspotOppsyncAccountIdFromState,
  getPartnerIdFromState,
  getTenantPartnerIdFromState,
} from '../../../../common/utils/Hooks/partnerStateSelectors'
import { isAdminRole } from '../../../../common/utils/isAdminRole'
//import { ProjectDetails } from '../../../components/CoSell/ReferralForm/ProjectDetailsForm/ProjectDetails/ProjectDetails.tsx'
import { formikErrorsToReferral } from '../../../../common/utils/CoSellHelpers/formikErrorsToReferral'
import { prepareLabraReferralObjectForClone } from '../../../../externalApps/HubspotApp/ReferralForm/hubspotReferralCloneUtils'

import { ReferralFormActions } from './actionTypes'
import {
  isAcceptRejectOnlyPayload,
  partitionSanitizedReferralForMerge,
  resolveOfferIdForSubmit,
} from './referralPayloadMerge'
import { emitSalesforceResourceSaved } from '@labrav/common'

const getPartnerIdFromSecureKey = (): string => {
  const secureKey = getSecureKey()
  if (!secureKey) {
    return ''
  }
  try {
    return getClaimsFromToken(secureKey).partnerId || ''
  } catch {
    return ''
  }
}

const resolveHubspotReferralPartnerId = (
  state: RootState,
  pathname: string,
  partnerType: PartnerType
): string =>
  getHubspotCosellAccountIdFromPath(pathname) ||
  getPartnerIdFromState(state, pathname, partnerType) ||
  getHubspotOppsyncAccountIdFromState(state) ||
  getTenantPartnerIdFromState(state, partnerType) ||
  state.customForm.hubspotForm.customData?.referralMetadata?.partner_id ||
  getPartnerIdFromSecureKey() ||
  ''

export const setReferralCreationData = (
  onboardingFormData: Partial<ReferralOppSections>
) => ({
  type: ReferralFormActions.SET_REFERRAL_FORM,
  payload: onboardingFormData,
})

export const setSelectedProduct = (selectedProduct: string) => ({
  type: ReferralFormActions.SET_SELECTED_PRODUCT,
  payload: selectedProduct,
})

export const setProductListData = (productsData: ProductListType[]) => ({
  type: ReferralFormActions.SET_PRODUCTS_LIST,
  payload: productsData,
})

export const setSelectedPrivateOffer = (
  selectedPrivateOfferId: string,
  selectedPrivateOfferName: string
) => ({
  type: ReferralFormActions.SET_SELECTED_PRIVATE_OFFER,
  payload: {
    selectedPrivateOfferId,
    selectedPrivateOfferName,
  },
})

export const setPrivateOffersData = (privateOffersData: ProductListType[]) => ({
  type: ReferralFormActions.SET_PRIVATE_OFFERS_LIST,
  payload: privateOffersData,
})

export const setOffersData = (offersData: offerData) => ({
  type: ReferralFormActions.SET_LINKED_PRIVATE_OFFER_DATA,
  payload: offersData,
})

export const setAwsMarketplaceOffers = (offers: string[]) => ({
  type: ReferralFormActions.SET_AWS_MARKETPLACE_OFFERS,
  payload: offers,
})

export const setNextStepInputMessage = (message: string) => ({
  type: ReferralFormActions.SET_NEXT_STEP_INPUT_MESSAGE,
  payload: message,
})

export const clearReferralForm = () => ({
  type: ReferralFormActions.CLEAR_REFERRAL_FORM,
})

export type ReferralChangeType = {
  sectionName: ReferralFormSectionName
  data:
    | Partial<CustomerDetails>
    | Partial<ProjectDetails>
    | Partial<AwsDetails>
    | Partial<SaaSDocumentation>
}

export const setReferralDetails = (referral: PartialReferralObject) => ({
  type: ReferralFormActions.SET_REFERRAL,
  payload: referral,
})

export const updateReferralCreationData = (data: ReferralChangeType) => ({
  type: ReferralFormActions.UPDATE_REFERRAL_FORM,
  payload: data,
})

export const emptyReferralFormFieldErrors = {} as Record<keyof Referral, string>

export const setFormFieldErrors = (errors: Record<keyof Referral, string>) => ({
  type: ReferralFormActions.SET_FORM_REFERRAL_ERRORS,
  payload: errors,
})

export const submitReferralFormForAutosave =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    supportMultiCloudForHubspot?: boolean
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    // Check if we're in Salesforce context for autosave too
    //const isSalesforce = isSalesforceContext(getState)

    try {
      // Get the latest referralId from state to avoid race conditions
      // This ensures we always use the most up-to-date referralId after previous autosaves
      const state = getState()
      const latestReferralId =
        referralId ||
        state.referralFormCreation.referral?.referralMetadata?.referralId

      const inHubspot = isHubSpotContext()
      const submitFn =
        inHubspot && supportMultiCloudForHubspot
          ? _submitMultiCloudHubspotReferralForm
          : inHubspot
            ? _submitReferralForm
            : _submitSalesforceReferralForm

      dispatch(
        autoSave('coSellReferralForm', () =>
          dispatch(submitFn(referral, status, latestReferralId))
        )
      )
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }

export const submitReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    referralType: CosellReferralType = 'opportunity',
    templateId?: string,
    cloudType: CloudType = CloudType.AWS,
    supportMultiCloudForHubspot?: boolean
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(REFERRAL_FORM_LOADING))

    // Get appropriate functions based on referral type and cloud type
    const { submitFn, setErrorsAction, mapApiToRef } = getSubmitFunctions(
      referralType,
      cloudType,
      supportMultiCloudForHubspot
    )
    if (status === 'draft') {
      dispatch(setErrorsAction({} as any))
    }
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const result: any = await dispatch(
        submitFn(referral, status, referralId, actionType, templateId) as any
      )

      if (result && result.error) throw result.error
      dispatch(
        updateAppAlert({
          message:
            status === 'draft'
              ? 'Referral was successfully saved as draft.'
              : 'Referral was successfully submitted.',
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
      dispatch(setNextStepInputMessage(''))
      return result || { success: true }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      const errorResponse = error.response?.data

      if (errorResponse) {
        try {
          const parsedErrors = parseReferralAPIError(errorResponse)
          const parsedErrorsTransformed = mapApiToRef(parsedErrors)
          const globalState = getState()

          // Get the form structure to check if fields exist in formik form
          let referralFormObject: Record<string, object> | undefined
          if (referralType === 'lead') {
            referralFormObject = globalState.leadReferralForm?.referralForm as
              | Record<string, object>
              | undefined
          } else {
            // For opportunity and Azure, the form structure is directly in referralFormCreation.referralForm
            referralFormObject = globalState.referralFormCreation
              ?.referralForm as unknown as Record<string, object> | undefined
          }

          const shouldSetFieldValidationErrors = status !== 'draft'

          // For draft saves, do not hydrate validation errors into the form.
          if (
            shouldSetFieldValidationErrors &&
            !isEmpty(parsedErrorsTransformed)
          ) {
            dispatch(setErrorsAction(parsedErrorsTransformed as any)) // forcing any here to comply with Referral & ReferralLead type, but this could be handled by moving this error handling function outside and having 2 branches with different types, like with generics
          }

          // Reveal fields hidden by "Required fields only" (e.g. phone) when they error
          if (
            shouldSetFieldValidationErrors &&
            hasReferralErrorOnRequiredOnlyHiddenField(
              parsedErrors,
              parsedErrorsTransformed as Record<string, unknown>
            ) &&
            globalState.cosell?.oppsync?.isShowRequiredFieldsOnly
          ) {
            // SectionFields reads cosell.oppsync; keep that slice in sync
            dispatch(
              actionTypeWrapper(
                'oppsync',
                setIsShowRequiredFieldsOnly({
                  isShowRequiredFieldsOnly: false,
                })
              )
            )
          }

          // Filter errors: only show in alert those that don't exist in the formik form
          // Uses optimized function with field caching for fast lookups
          const errorsNotInForm = filterErrorsForNonExistentFormikFields(
            parsedErrors,
            parsedErrorsTransformed as Record<string, unknown>,
            referralFormObject
          )

          // Get specific error messages only for fields not in the formik form
          const specificErrorMessage = shouldSetFieldValidationErrors
            ? formatErrorMessagesForAlert(errorsNotInForm)
            : ''

          if (specificErrorMessage) {
            // Show the specific error message(s) from the API for fields not in formik form
            dispatch(
              updateAppAlert({
                message: specificErrorMessage,
                messageType: 'ERROR',
                autoClose: false,
              })
            )
          } else if (
            shouldSetFieldValidationErrors &&
            !isEmpty(parsedErrorsTransformed)
          ) {
            // All errors are shown in formik form fields, show generic message
            dispatch(
              updateAppAlert({
                message: cosellDefaultFieldsError,
                messageType: 'ERROR',
                autoClose: false,
              })
            )
          } else {
            // No specific errors, show generic failure message
            dispatch(
              updateAppAlert({
                message: getErrorMessages([RequestFailureMessage])(
                  e.response as AxiosResponse<ErrorResponse>
                ),
                messageType: 'ERROR',
                autoClose: false,
              })
            )
          }
        } catch (e) {
          console.error('Error while parsing the response payload', e)
          const globalState = getState()
          errorLogger({ globalState })(error as Error)
        }
      } else {
        dispatch(
          updateAppAlert({
            message: getErrorMessages([RequestFailureMessage])(
              e.response as AxiosResponse<ErrorResponse>
            ),
            messageType: 'ERROR',
            autoClose: false,
          })
        )
      }

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return { error: e }
    } finally {
      dispatch(stopLoading(REFERRAL_FORM_LOADING))
    }
  }

const _submitReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    templateId?: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const partnerData = getState().AccountData.user.partnerData
    const stage =
      getState().referralFormCreation.referralForm.projectDetails.stage ??
      getState().referralFormCreation.referralForm.extra?.stage

    const referralMetadataReferralFormCreation =
      getState().referralFormCreation.referral?.referralMetadata

    const referralMetadataCustomForm =
      getState().customForm.hubspotForm.customData?.referralMetadata
    // const partnerCentralUsersEmailCosell =
    //  getState().cosell.oppsync.partnerCentralUsers || []
    const partnerCentralUsersEmail =
      getState().customForm.hubspotForm.customData?.partnerCentralUsers || []
    const referralFromBackend =
      getState().referralFormCreation.referral?.referralObject
    const { acceptanceStatus, rejectionReason, nextStep, nextStepHistory } =
      getState().referralFormCreation.referralForm.projectDetails
    const offerId = resolveOfferIdForSubmit(
      referral[ReferralFormSectionName.AWS_DETAILS],
      getState().referralFormCreation.referralForm.awsDetails?.offerId
    )
    const objectCrmId =
      getState().referralFormCreation.referral?.referralObject?.Id
    const referredBy =
      getState().referralFormCreation.referral?.referralObjectTransformed
        ?.referredBy
    const extraData = {
      stage,
      acceptanceStatus,
      rejectionReason,
      nextStep,
      nextStepHistory,
      offerId,
    }
    const dataTransformToApiFormat = referralFormToAPI(
      {
        ...referral,
        extra: extraData,
      },
      objectCrmId
    )

    const { populatedFields, fieldsClearedToNull } =
      partitionSanitizedReferralForMerge(dataTransformToApiFormat)

    const partnerUserSelected = partnerCentralUsersEmail.filter(
      (p: PartnerCentralUsers) =>
        p.email ===
        referral[ReferralFormSectionName.PROJECT_DETAILS]?.opportunityOwnerEmail
    )[0]

    const partnerCentralUserName = `${capitalizeFirstLetter(
      partnerUserSelected?.first_name
    )} ${capitalizeFirstLetter(partnerUserSelected?.last_name)}`

    const referralPayload: Partial<ReferralAPI> = {
      ...referralFromBackend,
      ...populatedFields,
      ...fieldsClearedToNull,
      Labra__Referred_By__c: referredBy || 'Partner Referral',
      Labra__Last_Updated_By__c: ReferralUpdatedBy.LABRA_CRM,
      Labra__AWS_Partner_Central_User_Name__c: partnerCentralUserName,
    }

    const referralMetadata =
      referralMetadataReferralFormCreation ||
      camelize(referralMetadataCustomForm)
    const partnerDataFromCrm =
      getState().customForm.hubspotForm.customData?.labraSettingObject
    const saveReferralParams = {
      referralObject: referralPayload,
      invokeSync: status === 'submitted',
      referralMetadata: {
        ...referralMetadata,
        crmId: referralMetadata?.crmId || partnerData?.crmId || '',
        referralType: 'referral_opportunity' as ReferralMetadataType,
        referralStatus: status,
        crmParentTable: 'labra_referral',
        crmPrimaryKeyName: 'id',
      },
      labraSettingObject: {
        consultingPartner: false,
        technologyPartner: false,
        isv: (partnerData?.isIsv || partnerDataFromCrm?.isv) ?? false,
        srrp: (partnerData?.isSrrp || partnerDataFromCrm?.srrp) ?? false,
        accelerateProgram:
          (partnerData?.accelerateProgram ||
            partnerDataFromCrm?.accelerate_program) ??
          false,
        awsFieldsVersion:
          partnerData?.awsFieldsVersion ||
          partnerDataFromCrm?.aws_fields_version ||
          'v14',
      },
    }

    try {
      const { data } = await saveReferral(
        saveReferralParams,
        referralId,
        actionType,
        templateId
      )

      const { referral_id: newReferralId, object_crm_id: responseObjectCrmId } =
        data
      const lastReferralId = referralId ? referralId : newReferralId
      const lastObjectCrmId = responseObjectCrmId || objectCrmId
      await dispatch(
        setReferralDetails({
          referralMetadata: {
            ...saveReferralParams.referralMetadata,
            ...(!isEmpty(lastReferralId) && { referralId: lastReferralId }),
            ...(!isEmpty(lastObjectCrmId) && {
              crmPrimaryKeyValue: lastObjectCrmId,
            }),
            createdAt:
              saveReferralParams.referralMetadata.createdAt ||
              new Date().toISOString(),
          },
          referralObject: {
            ...referralPayload,
            ...(!isEmpty(lastObjectCrmId) && { Id: lastObjectCrmId }),
          },
        })
      )
      if (lastReferralId && partnerData?.partnerId) {
        await dispatch(
          fetchLabraReferralStatusHistory(partnerData.partnerId, lastReferralId)
        )
      }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      // intentionally returning error because redux does not bubble up the error
      return { error: e }
    }
  }

// Salesforce-specific referral submission function
// Uses different API endpoint and request body structure than Hubspot/Oppsync
const _submitSalesforceReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    templateId?: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const partnerData = getState().AccountData.user.partnerData
    const stage =
      getState().referralFormCreation.referralForm.projectDetails.stage ??
      getState().referralFormCreation.referralForm.extra?.stage ??
      'Prospect'

    const referralMetadataReferralFormCreation =
      getState().referralFormCreation.referral?.referralMetadata

    const referralMetadataCustomForm =
      getState().customForm.hubspotForm.customData?.referralMetadata

    const partnerCentralUsersEmail =
      getState().customForm.hubspotForm.customData?.partnerCentralUsers || []
    const referralFromBackend =
      getState().referralFormCreation.referral?.referralObject
    const { acceptanceStatus, rejectionReason, nextStep, nextStepHistory } =
      getState().referralFormCreation.referralForm.projectDetails
    const offerId = resolveOfferIdForSubmit(
      referral[ReferralFormSectionName.AWS_DETAILS],
      getState().referralFormCreation.referralForm.awsDetails?.offerId
    )
    const objectCrmId =
      getState().referralFormCreation.referral?.referralObject?.Id
    const referredBy =
      getState().referralFormCreation.referral?.referralObjectTransformed
        ?.referredBy

    // Salesforce-specific extraData construction (modify as needed)
    const extraData = {
      stage,
      acceptanceStatus,
      rejectionReason,
      nextStep,
      nextStepHistory,
      offerId,
      // Add Salesforce-specific fields here if needed
    }

    const dataTransformToApiFormat = referralFormToAPI(
      {
        ...referral,
        extra: extraData,
      },
      objectCrmId
    )

    const { populatedFields, fieldsClearedToNull } =
      partitionSanitizedReferralForMerge(dataTransformToApiFormat)

    const partnerUserSelected = partnerCentralUsersEmail.filter(
      (p: PartnerCentralUsers) =>
        p.email ===
        referral[ReferralFormSectionName.PROJECT_DETAILS]?.opportunityOwnerEmail
    )[0]

    const partnerCentralUserName = `${capitalizeFirstLetter(
      partnerUserSelected?.first_name
    )} ${capitalizeFirstLetter(partnerUserSelected?.last_name)}`

    const referralPayload: Partial<ReferralAPI> = {
      ...referralFromBackend,
      ...populatedFields,
      ...fieldsClearedToNull,
      Labra__Referred_By__c: referredBy || 'Partner Referral',
      Labra__Last_Updated_By__c: ReferralUpdatedBy.LABRA_CRM,
      Labra__AWS_Partner_Central_User_Name__c: partnerCentralUserName,
    }
    const referralMetadata =
      referralMetadataReferralFormCreation ||
      camelize(referralMetadataCustomForm)
    const partnerDataFromCrm =
      getState().customForm.hubspotForm.customData?.labraSettingObject

    // removing the use of awsAccountId from the request body and only using the partnerId
    const awsAccountId =
      getState().referralFormCreation.referralForm.awsDetails?.awsAccountId
    const accountId = partnerData?.partnerId || ''

    // Get partnerId for endpoint
    const partnerId = partnerData?.partnerId

    // Get parent_object_id from Salesforce record
    const parentOpportunityId = canvasAuthService.getRecord()?.recordId || ''

    // Salesforce-specific request body structure matching the new API format
    // When updating (actionType === 'patch'), don't include form_status if it's already submitted
    // Backend doesn't allow updating form_status when it's already submitted
    const currentFormStatus = (getState().referralFormCreation.referral as any)
      ?.form_status
    const referralMetadataStatus =
      referralMetadataReferralFormCreation?.referralStatus ||
      (referralMetadataCustomForm as any)?.referral_status

    // Align update detection with saveReferral (PATCH when referralId exists).
    const isUpdate =
      actionType === 'patch' || actionType === 'put' || Boolean(referralId)
    const isUpdatingSubmittedReferral =
      isUpdate &&
      (currentFormStatus === 'submitted' ||
        referralMetadataStatus === 'submitted')
    const shouldIncludeFormStatus = !isUpdate || !isUpdatingSubmittedReferral

    // Build params object conditionally to ensure form_status is not included when updating submitted referrals
    const baseParams = {
      object_type: 'opportunity' as const,
      //referred_by: referredBy || 'Partner Referral',
      referred_by: 'partner',
      labra_referral: referralPayload, // All Salesforce fields go here
      crm_object_id: objectCrmId || undefined, // Optional: CRM object ID for updates
      cloud_object_id: undefined, // Optional: Cloud object ID
      parent_object_id: parentOpportunityId || undefined, // Optional: Parent opportunity ID

      cloud_type: 'AWS' as const,
      account_id: accountId, // Required: Account UUID
    }

    // Only add form_status if allowed (not updating submitted referrals)
    const saveReferralParams: SaveReferralAPIParams = shouldIncludeFormStatus
      ? {
          ...baseParams,
          form_status: status as 'draft' | 'submitted',
        }
      : {
          ...baseParams,
        }
    const acceptRejectStatus =
      referral[ReferralFormSectionName.PROJECT_DETAILS]?.acceptanceStatus ??
      acceptanceStatus
    const acceptRejectReason =
      referral[ReferralFormSectionName.PROJECT_DETAILS]?.rejectionReason ??
      rejectionReason
    const isAcceptRejectPatch =
      actionType === 'patch' &&
      referralId &&
      partnerId &&
      isAcceptRejectOnlyPayload(referral)

    if (isAcceptRejectPatch) {
      try {
        if (acceptRejectStatus === 'Accepted') {
          await acceptReferral(partnerId, referralId)
        } else {
          await rejectReferral(partnerId, referralId, {
            labra_referral: {
              Labra__Rejection_reason__c: acceptRejectReason ?? '',
            },
          })
        }
        const formStatusFromApi = 'submitted'
        const updatedReferralMetadata = {
          ...referralMetadata,
          crmId: referralMetadata?.crmId || partnerData?.crmId || '',
          referralType: 'referral_opportunity' as ReferralMetadataType,
          referralStatus: status,
          crmParentTable: 'labra_referral',
          crmPrimaryKeyName: 'id',
          ...(referralId && !isEmpty(referralId) && { referralId }),
          ...(!isEmpty(objectCrmId) && {
            crmPrimaryKeyValue: objectCrmId,
          }),
          createdAt: referralMetadata?.createdAt || new Date().toISOString(),
        }
        await dispatch(
          setReferralDetails({
            referralMetadata: updatedReferralMetadata,
            referralObject: {
              ...referralPayload,
              ...(referralId && { Id: objectCrmId }),
            },
            form_status: formStatusFromApi,
          })
        )
        return
      } catch (e: any) {
        const error = e as AxiosError<APIReferralError>
        const globalState = getState()
        errorLogger({ globalState })(error as Error)
        return { error: e }
      }
    }

    try {
      // Use Salesforce-specific API function
      const { data } = await saveSalesforceReferral(
        saveReferralParams,
        referralId,
        actionType,
        templateId,
        partnerId
      )

      // Handle response - adjust field names based on actual API response structure
      const newReferralId = data.referral_id || data.id || referralId
      const responseCrmObjectId =
        data.object_crm_id || data.crm_object_id || objectCrmId
      const lastReferralId = referralId ? referralId : newReferralId
      // Get form_status from API response (it's at the top level of the response)
      const formStatusFromApi = data.form_status || status

      // Update referral metadata for state management
      // Always set referralId if newReferralId exists (from API response)
      // This ensures referralId is stored in state after creation, preventing duplicate referrals
      const updatedReferralMetadata = {
        ...referralMetadata,
        crmId: referralMetadata?.crmId || partnerData?.crmId || '',
        referralType: 'referral_opportunity' as ReferralMetadataType,
        referralStatus: status,
        crmParentTable: 'labra_referral',
        crmPrimaryKeyName: 'id',
        ...(newReferralId &&
          !isEmpty(newReferralId) && { referralId: newReferralId }),
        ...(!isEmpty(responseCrmObjectId) && {
          crmPrimaryKeyValue: responseCrmObjectId,
        }),
        createdAt: referralMetadata?.createdAt || new Date().toISOString(),
      }

      await dispatch(
        setReferralDetails({
          referralMetadata: updatedReferralMetadata,
          referralObject: {
            ...referralPayload,
            ...(!isEmpty(lastReferralId) && { Id: responseCrmObjectId }),
          },
          // Store form_status from API response at the top level of referral object
          form_status: formStatusFromApi,
        })
      )

      if (lastReferralId && partnerId) {
        await dispatch(
          fetchLabraReferralStatusHistory(partnerId, lastReferralId)
        )
      }

      emitSalesforceResourceSaved({
        resourceType: 'referral',
        partnerId: partnerId || '',
        opportunityId: parentOpportunityId || null,
        referral: {
          id: newReferralId,
          draft: formStatusFromApi === 'draft',
        },
      })
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return { error: e }
    }
  }

export const linkReferralOpportunity =
  (opportunity: OpportunityOption) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const opportunityId = (opportunity.crmId || opportunity.key)?.trim()
    const partnerId = getState().AccountData.user.partnerData?.partnerId
    const referralId =
      getState().referralFormCreation.referral?.referralMetadata?.referralId

    if (!opportunityId || !partnerId || !referralId) {
      dispatch(
        updateAppAlert({
          message: 'Unable to link opportunity. Referral context is missing.',
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      return { error: new Error('Missing link opportunity context') }
    }

    try {
      await linkOpportunity(partnerId, referralId, {
        labra_referral: {},
        parent_object_id: opportunityId,
      })
      const referral = getState().referralFormCreation.referral
      dispatch(
        setReferralDetails({
          referralObject: referral?.referralObject || {},
          referralSyncs: referral?.referralSyncs,
          form_status: referral?.form_status,
          referralMetadata: {
            ...referral?.referralMetadata,
            parentObjectId: opportunityId,
          },
        })
      )
      return { success: true as const }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      errorLogger({ globalState: getState() })(error as Error)
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error.response as AxiosResponse
          ),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      return { error: e }
    }
  }

export const hydrateLinkedOpportunityFromCrm =
  ({ crmId, parentObjectId }: { crmId: string; parentObjectId: string }) =>
  async (): Promise<
    { opportunity: OpportunityOption } | { deleted: true } | undefined
  > => {
    if (isHubSpotContext()) return

    const resolvedCrmId = crmId?.trim()
    const resolvedParentObjectId = parentObjectId?.trim()
    if (!resolvedCrmId || !resolvedParentObjectId) return

    try {
      const [recordResult, linksResult] = await Promise.allSettled([
        getRecordByRecordId(
          resolvedCrmId,
          'Opportunity',
          resolvedParentObjectId,
          'Name,StageName'
        ),
        fetchCrmObjectLinks(resolvedCrmId, [resolvedParentObjectId]),
      ])

      if (recordResult.status === 'rejected') {
        return { deleted: true }
      }

      const link =
        linksResult.status === 'fulfilled'
          ? linksResult.value?.data?.[resolvedParentObjectId]
          : undefined
      const opportunity = crmOpportunityToOption(
        recordResult.value?.data ?? {},
        link
      )
      if (!opportunity) {
        return { deleted: true }
      }

      return { opportunity }
    } catch {
      return { deleted: true }
    }
  }

/** Partner/account UUID for Salesforce engine APIs when HubSpot multi-cloud is on. */
const getPartnerIdForHubspotMultiCloudThunk = (
  getState: () => RootState
): string => {
  const state = getState()
  const pathname =
    typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : ''
  const partnerType = isAdminRole(state.userProfile.userProfile)
    ? PartnerType.Admin
    : PartnerType.User

  return (
    resolveHubspotReferralPartnerId(state, pathname, partnerType) ||
    state.AccountData[partnerType]?.partnerData?.partnerId ||
    ''
  )
}

const _submitMultiCloudHubspotReferralForm =
  (
    referral: Partial<ReferralOppSections>,
    status: ReferralMetadata['referralStatus'] = 'draft',
    referralId?: string,
    actionType?: ActionType,
    templateId?: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState()
    const partnerData = state.AccountData.user.partnerData
    const selectedPartnerAccountId =
      getPartnerIdForHubspotMultiCloudThunk(getState)
    const reduxProjectDetails =
      state.referralFormCreation.referralForm.projectDetails
    const reduxAwsDetails = state.referralFormCreation.referralForm.awsDetails
    const formProjectDetails = referral[ReferralFormSectionName.PROJECT_DETAILS]
    const formAwsDetails = referral[ReferralFormSectionName.AWS_DETAILS]

    const referralMetadataReferralFormCreation =
      state.referralFormCreation.referral?.referralMetadata

    const referralMetadataCustomForm =
      state.customForm.hubspotForm.customData?.referralMetadata
    // const partnerCentralUsersEmailCosell =
    //  getState().cosell.oppsync.partnerCentralUsers || []
    const partnerCentralUsersEmail =
      state.customForm.hubspotForm.customData?.partnerCentralUsers || []
    const referralFromBackend =
      state.referralFormCreation.referral?.referralObject
    const {
      acceptanceStatus = reduxProjectDetails.acceptanceStatus,
      rejectionReason = reduxProjectDetails.rejectionReason,
      nextStep = reduxProjectDetails.nextStep,
      nextStepHistory = reduxProjectDetails.nextStepHistory,
    } = formProjectDetails ?? {}
    const offerId = resolveOfferIdForSubmit(
      formAwsDetails,
      reduxAwsDetails.offerId
    )
    const objectCrmId = state.referralFormCreation.referral?.referralObject?.Id
    const referredBy =
      state.referralFormCreation.referral?.referralObjectTransformed?.referredBy
    const extraData = {
      stage: formProjectDetails?.stage ?? reduxProjectDetails.stage,
      acceptanceStatus,
      rejectionReason,
      nextStep,
      nextStepHistory,
      offerId,
    }
    const dataTransformToApiFormat = referralFormToAPI(
      {
        ...referral,
        extra: extraData,
      },
      objectCrmId
    )

    const { populatedFields, fieldsClearedToNull } =
      partitionSanitizedReferralForMerge(dataTransformToApiFormat)

    const partnerUserSelected = partnerCentralUsersEmail.filter(
      (p: PartnerCentralUsers) =>
        p.email ===
        referral[ReferralFormSectionName.PROJECT_DETAILS]?.opportunityOwnerEmail
    )[0]

    const partnerCentralUserName = `${capitalizeFirstLetter(
      partnerUserSelected?.first_name
    )} ${capitalizeFirstLetter(partnerUserSelected?.last_name)}`

    const referralPayload: Partial<ReferralAPI> = {
      ...referralFromBackend,
      ...populatedFields,
      ...fieldsClearedToNull,
      Labra__Referred_By__c: referredBy || 'Partner Referral',
      Labra__Last_Updated_By__c: ReferralUpdatedBy.LABRA_CRM,
      Labra__AWS_Partner_Central_User_Name__c: partnerCentralUserName,
    }

    const referralMetadata =
      referralMetadataReferralFormCreation ||
      camelize(referralMetadataCustomForm)

    // Partner/cloud-account UUID. Do not use awsDetails.awsAccountId here —
    // that 12-digit customer AWS account belongs on Labra__AWS_Account_Id__c.
    const accountId = selectedPartnerAccountId || partnerData?.partnerId || ''
    const partnerId =
      selectedPartnerAccountId || partnerData?.partnerId || undefined
    const parentOpportunityId = canvasAuthService.getRecord()?.recordId || ''

    const currentFormStatus = (state.referralFormCreation.referral as any)
      ?.form_status
    const referralMetadataStatus =
      referralMetadataReferralFormCreation?.referralStatus ||
      (referralMetadataCustomForm as any)?.referral_status

    const isUpdate =
      actionType === 'patch' || actionType === 'put' || Boolean(referralId)
    const isUpdatingSubmittedReferral =
      isUpdate &&
      (currentFormStatus === 'submitted' ||
        referralMetadataStatus === 'submitted')
    const shouldIncludeFormStatus = !isUpdate || !isUpdatingSubmittedReferral

    const partnerDataFromCrm =
      getState().customForm.hubspotForm.customData?.labraSettingObject

    const locationSearch =
      typeof window !== 'undefined' && window.location?.search
        ? window.location.search
        : ''
    const searchParams = new URLSearchParams(locationSearch)
    const dealIdFromUrl =
      searchParams.get('hs_object_id')?.trim().toLowerCase() ||
      searchParams.get('crm_opportunity_id')?.trim() ||
      undefined

    const baseParams: SaveReferralAPIParams = {
      object_type: 'opportunity' as const,
      referred_by: 'partner',
      labra_referral: referralPayload,
      crm_object_id:
        referralMetadata.crmPrimaryKeyValue || objectCrmId || undefined,
      cloud_object_id: undefined,
      parent_object_id: dealIdFromUrl || undefined,
      cloud_type: 'AWS' as const,
      account_id: accountId,
    }

    const saveReferralParams: SaveReferralAPIParams = shouldIncludeFormStatus
      ? {
          ...baseParams,
          form_status: status as 'draft' | 'submitted',
        }
      : {
          ...baseParams,
        }

    const acceptRejectStatus =
      referral[ReferralFormSectionName.PROJECT_DETAILS]?.acceptanceStatus ??
      acceptanceStatus
    const acceptRejectReason =
      referral[ReferralFormSectionName.PROJECT_DETAILS]?.rejectionReason ??
      rejectionReason
    const isAcceptRejectPatch =
      actionType === 'patch' &&
      referralId &&
      partnerId &&
      isAcceptRejectOnlyPayload(referral)

    if (isAcceptRejectPatch) {
      try {
        if (acceptRejectStatus === 'Accepted') {
          await acceptReferral(partnerId, referralId)
        } else {
          await rejectReferral(partnerId, referralId, {
            labra_referral: {
              Labra__Rejection_reason__c: acceptRejectReason ?? '',
            },
          })
        }
        const formStatusFromApi = 'submitted'
        const updatedReferralMetadata = {
          ...referralMetadata,
          crmId: referralMetadata?.crmId || partnerData?.crmId || '',
          referralType: 'referral_opportunity' as ReferralMetadataType,
          referralStatus: status,
          crmParentTable: 'labra_referral',
          crmPrimaryKeyName: 'id',
          ...(referralId && !isEmpty(referralId) && { referralId }),
          ...(!isEmpty(objectCrmId) && {
            crmPrimaryKeyValue: objectCrmId,
          }),
          createdAt: referralMetadata?.createdAt || new Date().toISOString(),
          ...(partnerId && !isEmpty(partnerId) && { partner_id: partnerId }),
        }
        await dispatch(
          setReferralDetails({
            referralMetadata: updatedReferralMetadata,
            referralObject: {
              ...referralPayload,
              ...(referralId && { Id: objectCrmId }),
            },
            form_status: formStatusFromApi,
          })
        )
        return
      } catch (e: any) {
        const error = e as AxiosError<APIReferralError>
        const globalState = getState()
        errorLogger({ globalState })(error as Error)
        return { error: e }
      }
    }

    try {
      const { data } = await saveSalesforceReferral(
        saveReferralParams,
        referralId,
        actionType,
        templateId,
        partnerId
      )

      const newReferralId = data.referral_id || data.id || referralId
      const responseCrmObjectId =
        data.object_crm_id || data.crm_object_id || objectCrmId
      const lastReferralId = referralId ? referralId : newReferralId
      const formStatusFromApi = data.form_status || status

      const updatedReferralMetadata = {
        ...referralMetadata,
        crmId: referralMetadata?.crmId || partnerData?.crmId || '',
        referralType: 'referral_opportunity' as ReferralMetadataType,
        referralStatus: status,
        crmParentTable: 'labra_referral',
        crmPrimaryKeyName: 'id',
        ...(newReferralId &&
          !isEmpty(newReferralId) && { referralId: newReferralId }),
        ...(!isEmpty(responseCrmObjectId) && {
          crmPrimaryKeyValue: responseCrmObjectId,
        }),
        createdAt: referralMetadata?.createdAt || new Date().toISOString(),
        ...(partnerId && !isEmpty(partnerId) && { partner_id: partnerId }),
      }

      await dispatch(
        setReferralDetails({
          referralMetadata: updatedReferralMetadata,
          referralObject: {
            ...referralPayload,
            ...(!isEmpty(lastReferralId) && { Id: responseCrmObjectId }),
          },
          form_status: formStatusFromApi,
        })
      )
      if (lastReferralId && partnerId) {
        await dispatch(
          fetchLabraReferralStatusHistory(partnerId, lastReferralId)
        )
      }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>

      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return { error: e }
    }
  }

const referralFormToAPI = (
  values: Partial<ReferralOppSections>,
  objectCrmId?: string
): Partial<ReferralAPI> => {
  const {
    customerDetails,
    contacts,
    projectDetails,
    awsDetails,
    saasDocumentation,
    awsContactsDetails,
    extra,
  } = values

  const s = trimReferralStringField
  const customerPhone = s(customerDetails?.phone)
  const isFromMarketing = projectDetails?.isThisFromMarketing === 'Yes'

  return {
    Id: objectCrmId,
    Name: s(projectDetails?.partnerProjectTitle),
    Labra__IsOppFromMarketingActivity__c: trimReferralMarketingActivityFlag(
      projectDetails?.isThisFromMarketing
    ),
    Labra__Labra_ACE_CRM_Lead_UniqueIdentifier__c: undefined,
    Labra__apnReviewerComments__c: undefined,
    Labra__Sync_to_AWS__c: true,
    Labra__awsSFCampaignName__c: isFromMarketing
      ? s(projectDetails?.marketingCampaignCode)
      : '',
    Labra__Offer_ID__c: s(extra?.offerId) ?? null,
    Labra__Other_Solution_Offered__c: projectDetails?.solutionOffered?.includes(
      'Other'
    )
      ? (s(projectDetails?.otherSolutionOffered) ?? null)
      : null,
    Labra__Parent_Opportunity_ID__c: s(projectDetails?.parentOpportunityId),
    Labra__Partner_Contact_Title__c:
      s(contacts?.partnerSalesContactTitle) || 'PartnerAccountManager',
    Labra__AWS_Recommended_Action__c: s(awsDetails?.recommendedNextBestActions),
    Labra__AWS_Marketplace_Engagement_Score__c: s(awsDetails?.engagementScore),
    Labra__APN_CRM_Unique_Identifier__c: undefined,
    Labra__AWS_Account_Id__c: s(awsDetails?.awsAccountId),
    Labra__Campaign_Name__c: awsDetails?.apnProgram?.join(';'),
    Labra__AWS_Account_Owner_Email__c: s(
      awsContactsDetails?.awsAccountManagerEmail
    ),
    Labra__AWS_Account_Owner_Name__c: s(
      awsContactsDetails?.awsAccountManagerName
    ),
    Labra__AWS_Internal_Stage__c: undefined,
    Labra__AWS_Partner_Central_User_Email__c: s(
      projectDetails?.opportunityOwnerEmail
    ),
    Labra__AWS_Partner_Central_User_Name__c: s(
      projectDetails?.opportunityOwnerName
    ),
    Labra__AWS_Sales_Rep_Email__c: s(awsContactsDetails?.awsSalesRepEmail),
    Labra__AWS_Sales_Rep_Name__c: s(awsContactsDetails?.awsSalesRepName),
    Labra__City__c: s(customerDetails?.city),
    Labra__Company_Name__c: s(customerDetails?.companyName),
    Labra__Country__c: s(customerDetails?.country),
    Labra__Primary_Sales_Rep_Email__c: s(contacts?.partnerSalesContactEmail),
    Labra__Primary_Sales_Rep_First_Name__c: s(
      contacts?.partnerContactFirstName
    ),
    Labra__Primary_Sales_Rep_Last_Name__c: s(contacts?.partnerContactLastName),
    Labra__Primary_Sales_Rep_Phone__c: s(contacts?.partnerSalesContactPhone),
    Labra__Delivery_Model__c: projectDetails?.deliveryModel?.join(';'),
    Labra__Description__c: trimReferralBusinessProblemForApi(
      projectDetails?.customerBusinessProblem
    ),
    Labra__Expected_Monthly_AWS_Revenue__c:
      projectDetails?.expectedMonthlyAwsRevenue,
    Labra__ISV_Manager_Email__c: s(
      awsContactsDetails?.awsIsvSuccessManagerEmail
    ),
    Labra__ISV_Manager_Name__c: s(awsContactsDetails?.awsIsvSuccessManagerName),
    Labra__Industry__c: s(customerDetails?.industry),
    Labra__Next_Step_History__c: s(extra?.nextStepHistory),
    Labra__Next_step__c: s(extra?.nextStep),
    Labra__Sender_Company_Name__c: s(awsDetails?.senderCompanyName),
    Labra__Sender_Company_Domain__c: s(awsDetails?.senderCompanyDomain),
    Labra__Sender_Contact_Email__c: s(awsDetails?.senderContactEmail),
    Labra__Sender_Contact_First_Name__c: s(awsDetails?.senderContactFirstName),
    Labra__Sender_Contact_Last_Name__c: s(awsDetails?.senderContactLastName),
    Labra__Competitive_Tracking__c: s(awsDetails?.competitiveTracking),
    Labra__Other_Competitive_Tracking__c: s(
      awsDetails?.competitiveTrackingOther
    ),
    Labra__Other_Industry__c: (() => {
      const otherIndustry = s(customerDetails?.otherIndustry)
      return isEmpty(otherIndustry) ? null : otherIndustry
    })(),
    Labra__Other_PDM_Email__c: s(awsContactsDetails?.wwpsPdmEmail),
    Labra__Other_PDM__c: s(awsContactsDetails?.wwpsPdm),
    Labra__PDM_Email__c: s(awsContactsDetails?.pdmEmail),
    Labra__PDM__c: s(awsContactsDetails?.pdmName),
    Labra__Postal_Code__c: trimReferralPostalCodeForApi(
      customerDetails?.country,
      customerDetails?.postalCode
    ),
    Labra__Primary_Need_From_AWS_MultiSelect__c:
      projectDetails?.partnerPrimaryNeedFromAws?.join(';'),

    Labra__State__c: s(customerDetails?.state),
    Labra__Street_Address__c: s(customerDetails?.streetAddress),
    Labra__Success_Manager_Email__c: s(awsContactsDetails?.psmEmail),
    Labra__Success_Manager_Name__c: s(awsContactsDetails?.psmName),
    Labra__Use_Case__c: s(projectDetails?.useCase),
    Labra__Website__c: s(customerDetails?.website),
    Labra__Target_Close_Date__c: projectDetails?.targetCloseDate,
    Labra__Solution_offered__c: projectDetails?.solutionOffered?.join(';'),
    Labra__Opportunity_Type__c: s(projectDetails?.opportunityType),
    Labra__Sales_Activities__c:
      projectDetails?.referredBy?.includes('AWS') &&
      isEmpty(projectDetails?.salesActivities)
        ? undefined
        : projectDetails?.salesActivities?.join(';'),
    Labra__Customer_DUNS__c: s(customerDetails?.duns),
    Labra__AWS_products__c: awsDetails?.awsProducts?.join(';'),
    Labra__Referral_Stage__c: s(extra?.stage),
    Labra__Rejection_reason__c: s(extra?.rejectionReason),
    Labra__Acceptance_Status__c: s(extra?.acceptanceStatus) ?? 'Accepted',
    Labra__AWS_Closed_Lost_Reason__c: s(awsDetails?.closedReason),
    Labra__AWS_Closed_Lost_Reason_Code__c: undefined,
    Labra__Has_classified_NatSec_Information__c: s(
      customerDetails?.hasClassifiedNationalSecurityInformation
    ),
    Labra__Additional_Comments__c: s(projectDetails?.additionalComments),
    Labra__AWS_Close_Date__c: awsDetails?.awsCloseDate,
    Labra__contractStartDate__c: saasDocumentation?.contractEffectiveDate,
    Labra__contractEndDate__c: saasDocumentation?.contractExpirationDate,
    Labra__customerSoftwareValueCurrency__c: s(saasDocumentation?.currency),
    Labra__customerSoftwareValue__c:
      saasDocumentation?.customerSoftwareValue || null,
    Labra__procurementType__c: saasDocumentation?.procurementType,
    Labra__Customer_Email__c: s(customerDetails?.email),
    Labra__Customer_First_Name__c: s(customerDetails?.firstName),
    Labra__Customer_Last_Name__c: s(customerDetails?.lastName),
    Labra__Customer_Phone__c:
      customerPhone && (customerPhone.replace(/\D/g, '').length ?? 0) > 3
        ? customerPhone
        : '',
    Labra__Customer_Title__c: s(customerDetails?.title),
    Labra__marketingActivityChannel__c: isFromMarketing
      ? projectDetails?.marketingActivityChannel === null
        ? null
        : projectDetails?.marketingActivityChannel?.join(';')
      : '',
    Labra__marketingActivityUsecase__c: isFromMarketing
      ? projectDetails?.marketingActivityUseCase === null
        ? null
        : projectDetails?.marketingActivityUseCase?.join(';')
      : '',
    Labra__MDF_Needed__c: isFromMarketing
      ? s(projectDetails?.marketingFundsUsed)
      : '',
    Labra__Referred_By__c: s(projectDetails?.referredBy),
  }
}

// Salesforce may return multi-select fields as a string ("A;B;C") or already as an array.
const splitSemicolon = (
  value: string | string[] | null | undefined
): string[] => {
  if (Array.isArray(value)) return value
  if (typeof value === 'string' && value) return value.split(';')
  return []
}

export const referralAPIToForm = (
  values: Partial<ReferralAPI>
): RecursivePartial<ReferralOppSections> => {
  // Helper to convert null to empty string for string fields
  // This ensures form validation works the same way as creating from scratch
  const nullToEmpty = (value: string | null | undefined): string | undefined =>
    value === null ? '' : value

  // Helper to process an object and apply nullToEmpty to all string values
  const processStringFields = <T extends Record<string, any>>(obj: T): T => {
    const processed = { ...obj }
    for (const key in processed) {
      const value = processed[key]
      if (typeof value === 'string' || value === null || value === undefined) {
        processed[key] = nullToEmpty(value) as any
      }
    }
    return processed
  }

  const result = {
    customerDetails: {
      companyName: values.Labra__Company_Name__c,
      country: values.Labra__Country__c,
      industry: values.Labra__Industry__c,
      otherIndustry: values.Labra__Other_Industry__c,
      website: values.Labra__Website__c,
      city: values.Labra__City__c,
      duns: values.Labra__Customer_DUNS__c,
      postalCode: values.Labra__Postal_Code__c,
      state: values.Labra__State__c,
      streetAddress: values.Labra__Street_Address__c,
      firstName: values.Labra__Customer_First_Name__c,
      lastName: values.Labra__Customer_Last_Name__c,
      email: values.Labra__Customer_Email__c,
      phone: values.Labra__Customer_Phone__c,
      title: values.Labra__Customer_Title__c,
      hasClassifiedNationalSecurityInformation:
        values.Labra__Has_classified_NatSec_Information__c,
    },
    projectDetails: {
      customerBusinessProblem: values.Labra__Description__c?.replace(
        /\u200B+$/g,
        ''
      ).trimEnd(),
      deliveryModel: splitSemicolon(values.Labra__Delivery_Model__c),
      // CRM / template may omit the field or send ''; ?? only covers null/undefined.
      isThisFromMarketing: (() => {
        const raw = values.Labra__IsOppFromMarketingActivity__c
        if (raw == null) return 'No'
        const trimmed = String(raw).trim()
        return trimmed === '' ? 'No' : trimmed
      })(),
      marketingFundsUsed: values.Labra__MDF_Needed__c,
      parentOpportunityId: values.Labra__Parent_Opportunity_ID__c,
      opportunityOwnerEmail: values.Labra__AWS_Partner_Central_User_Email__c,
      opportunityOwnerName: values.Labra__AWS_Partner_Central_User_Name__c,
      opportunityType: values.Labra__Opportunity_Type__c,
      partnerPrimaryNeedFromAws: splitSemicolon(
        values.Labra__Primary_Need_From_AWS_MultiSelect__c
      ),
      partnerProjectTitle: values.Name,
      salesActivities: splitSemicolon(values.Labra__Sales_Activities__c),
      solutionOffered: splitSemicolon(values.Labra__Solution_offered__c),
      otherSolutionOffered: values.Labra__Other_Solution_Offered__c,
      targetCloseDate: values.Labra__Target_Close_Date__c,
      useCase: values.Labra__Use_Case__c,
      expectedMonthlyAwsRevenue:
        values.Labra__Expected_Monthly_AWS_Revenue__c === null
          ? undefined
          : values.Labra__Expected_Monthly_AWS_Revenue__c,
      marketingActivityChannel: splitSemicolon(
        values.Labra__marketingActivityChannel__c
      ),
      marketingActivityUseCase: splitSemicolon(
        values.Labra__marketingActivityUsecase__c
      ),
      marketingCampaignCode: values.Labra__awsSFCampaignName__c,
      referredBy: values.Labra__Referred_By__c,
      additionalComments: values.Labra__Additional_Comments__c,
      // These fields live in projectDetails (for form edits) AND extra (legacy).
      // Populating both ensures the submit action reads the correct value after
      // a page refresh, when only the GET-loaded form state is available.
      stage: (values.Labra__Referral_Stage__c ?? undefined) as
        | ReferralStage
        | undefined,
      nextStep: values.Labra__Next_step__c,
      nextStepHistory: values.Labra__Next_Step_History__c,
      acceptanceStatus: values.Labra__Acceptance_Status__c,
      rejectionReason: values.Labra__Rejection_reason__c,
    },
    contacts: {
      partnerContactFirstName: values.Labra__Primary_Sales_Rep_First_Name__c,
      partnerContactLastName: values.Labra__Primary_Sales_Rep_Last_Name__c,
      partnerSalesContactEmail: values.Labra__Primary_Sales_Rep_Email__c,
      partnerSalesContactPhone: values.Labra__Primary_Sales_Rep_Phone__c,
      partnerSalesContactTitle:
        values.Labra__Partner_Contact_Title__c || 'PartnerAccountManager',
    },
    awsDetails: {
      apnProgram: splitSemicolon(values.Labra__Campaign_Name__c),
      awsProducts: splitSemicolon(values.Labra__AWS_products__c),
      awsAccountId: values.Labra__AWS_Account_Id__c,
      offerId: values.Labra__Offer_ID__c,
      senderCompanyName: values.Labra__Sender_Company_Name__c,
      senderCompanyDomain: values.Labra__Sender_Company_Domain__c,
      senderContactEmail: values.Labra__Sender_Contact_Email__c,
      senderContactFirstName: values.Labra__Sender_Contact_First_Name__c,
      senderContactLastName: values.Labra__Sender_Contact_Last_Name__c,
      competitiveTracking: values.Labra__Competitive_Tracking__c,
      competitiveTrackingOther: values.Labra__Other_Competitive_Tracking__c,
      closedReason: values.Labra__AWS_Closed_Lost_Reason__c,
      awsClosedReason: values.Labra__AWS_Closed_Lost_Reason_Code__c,
      awsCloseDate: values.Labra__AWS_Close_Date__c,
      engagementScore: values.Labra__AWS_Marketplace_Engagement_Score__c,
      recommendedNextBestActions: values.Labra__AWS_Recommended_Action__c,
      customerSegment: values?.Labra__Customer_Segment__c,
      isGreenfield: values?.Labra__isGreenfield__c,
    },
    saasDocumentation: {
      contractEffectiveDate: values.Labra__contractStartDate__c,
      contractExpirationDate: values.Labra__contractEndDate__c,
      currency: values.Labra__customerSoftwareValueCurrency__c,
      customerSoftwareValue: values.Labra__customerSoftwareValue__c,
      procurementType: values.Labra__procurementType__c,
    },
    awsContactsDetails: {
      awsAccountManagerEmail: values.Labra__AWS_Account_Owner_Email__c,
      awsAccountManagerName: values.Labra__AWS_Account_Owner_Name__c,
      awsSalesRepEmail: values.Labra__AWS_Sales_Rep_Email__c,
      awsSalesRepName: values.Labra__AWS_Sales_Rep_Name__c,
      awsIsvSuccessManagerEmail: values.Labra__ISV_Manager_Email__c,
      awsIsvSuccessManagerName: values.Labra__ISV_Manager_Name__c,
      psmEmail: values.Labra__Success_Manager_Email__c,
      psmName: values.Labra__Success_Manager_Name__c,
      pdmEmail: values.Labra__PDM_Email__c,
      pdmName: values.Labra__PDM__c,
      wwpsPdmEmail: values.Labra__Other_PDM_Email__c,
      wwpsPdm: values.Labra__Other_PDM__c,
    },
    extra: {
      stage: values.Labra__Referral_Stage__c as ReferralStage,
      acceptanceStatus: values.Labra__Acceptance_Status__c,
      rejectionReason: values.Labra__Rejection_reason__c,
      nextStep: values.Labra__Next_step__c,
      nextStepHistory: values.Labra__Next_Step_History__c,
      offerId: values.Labra__Offer_ID__c,
    },
  }

  // Apply nullToEmpty to string fields in sections that need it
  return {
    customerDetails: processStringFields(result.customerDetails),
    projectDetails: processStringFields(result.projectDetails),
    contacts: processStringFields(result.contacts),
    awsDetails: result.awsDetails,
    saasDocumentation: result.saasDocumentation,
    awsContactsDetails: result.awsContactsDetails,
    extra: result.extra,
  }
}

const getReferralType = (referral: any): CosellReferralType => {
  if (referral?.referral_metadata?.referral_type === 'referral_lead') {
    return 'lead'
  }
  return 'opportunity'
}

interface ReferralActions {
  setReferralDetails:
    | typeof setReferralDetails
    | typeof setLeadDetails
    | typeof setAzureDetails
  setReferralCreationData:
    | typeof setReferralCreationData
    | typeof setLeadCreationData
    | typeof setAzureCreationData
  transform:
    | typeof referralAPIToForm
    | typeof mapLeadApiToForm
    | typeof mapAzureApiToForm
}

export const getReferralActions = (
  referralType: CosellReferralType,
  cloudType: CloudType = CloudType.AWS
): ReferralActions => {
  // If cloud is Azure, return Azure actions regardless of referral type
  if (cloudType === CloudType.AZURE) {
    return {
      setReferralDetails: setAzureDetails,
      setReferralCreationData: setAzureCreationData,
      transform: mapAzureApiToForm,
    }
  }

  // Default AWS flow
  switch (referralType) {
    case 'lead':
      return {
        setReferralDetails: setLeadDetails,
        setReferralCreationData: setLeadCreationData,
        transform: mapLeadApiToForm,
      }
    case 'opportunity':
      return {
        setReferralDetails: setReferralDetails,
        setReferralCreationData: setReferralCreationData,
        transform: referralAPIToForm,
      }
  }
}
// Helper to detect if we're in Salesforce context
/**
 * Helper function to check if we're running in Salesforce context
 * Uses canvasAuthService - matches the pattern from SidePanelWrapperV3:
 * salesforceContext.error !== 'salesforce_context_not_available'
 */
const isInSalesforceContext = (): boolean => {
  try {
    // Error condition 1: No valid partnerId
    const partnerId = canvasAuthService.getPartnerId()
    if (!partnerId || isEmpty(partnerId)) {
      return false
    }
    return true
  } catch {
    return false
  }
}

export const getSubmitFunctions = (
  referralType: CosellReferralType,
  cloudType: CloudType = CloudType.AWS,
  supportMultiCloudForHubspot?: boolean
) => {
  const inHubspot = isHubSpotContext()
  // If cloud is Azure, return Azure functions regardless of referral type
  if (cloudType === CloudType.AWS) {
    // Default AWS flow
    switch (referralType) {
      case 'lead':
        return {
          submitFn: submitLeadForm,
          setErrorsAction: setLeadFormFieldErrors,
          mapApiToRef: mapLeadApiToLead,
        }
      case 'opportunity': {
        const submitFn =
          inHubspot && supportMultiCloudForHubspot
            ? _submitMultiCloudHubspotReferralForm
            : inHubspot
              ? _submitReferralForm
              : _submitSalesforceReferralForm
        return {
          submitFn,
          setErrorsAction: setFormFieldErrors,
          mapApiToRef: mapReferralApiToReferral,
        }
      }
      default:
        const defaultSubmitFn =
          inHubspot && !supportMultiCloudForHubspot
            ? _submitReferralForm
            : inHubspot && supportMultiCloudForHubspot
              ? _submitMultiCloudHubspotReferralForm
              : _submitSalesforceReferralForm
        return {
          submitFn: defaultSubmitFn,
          setErrorsAction: setFormFieldErrors,
          mapApiToRef: mapReferralApiToReferral,
        }
    }
  }

  // Azure cloud flow
  if (cloudType === CloudType.AZURE) {
    return {
      submitFn: submitAzureForm,
      setErrorsAction: setAzureFormFieldErrors,
      mapApiToRef: mapAzureApiToForm,
    }
  }

  // Default to AWS opportunity for unknown cloud types
  return {
    submitFn: _submitReferralForm,
    setErrorsAction: setFormFieldErrors,
    mapApiToRef: mapReferralApiToReferral,
  }
}

export const getProductLists =
  (referralId: string, productType: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const { data } = await fetchProductsList(referralId, productType)

      const transformedData = data
        .map((item: any) => {
          let productTitle = ''
          switch (productType) {
            case 'AmiProduct':
              productTitle = item.AmiProductSummary?.ProductTitle || ''
              break
            case 'ContainerProduct':
              productTitle = item.ContainerProductSummary?.ProductTitle || ''
              break
            case 'SaaSProduct':
              productTitle = item.SaaSProductSummary?.ProductTitle || ''
              break
            case 'DataProduct':
              productTitle = item.DataProductSummary?.ProductTitle || ''
              break
          }
          return {
            entityId: item.EntityId,
            productTitle: productTitle,
          }
        })
        .filter((item: any) => item.productTitle)

      await dispatch(setProductListData(transformedData))
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }

export const getPrivateOffers =
  (referralId: string, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const { data } = await fetchPrivateOffersList(referralId, productId)
      const transformedData = data
        .map((item: any) => {
          return {
            entityId: item.EntityId,
            productTitle: item.OfferSummary?.Name || '',
          }
        })
        .filter((item: any) => item.productTitle)

      await dispatch(setPrivateOffersData(transformedData))
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }

export type PrivateOfferAgreement = {
  offer_id?: string
  tcv?: number
  procurement_type?: string
  currency?: string
  aws_account_id?: string
  start_date?: string
  end_date?: string
}

const privateOfferDateToYmd = (iso?: string) => {
  if (!iso || typeof iso !== 'string') return ''
  const day = iso.split('T')[0]
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : ''
}

export const mapAgreementToReferralForm = (
  agreement: PrivateOfferAgreement
): {
  awsDetails: Partial<AwsDetails>
  saasDocumentation: Partial<SaaSDocumentation>
} => {
  const tcv = agreement.tcv
  return {
    awsDetails: {
      offerId: agreement.offer_id ?? null,
      awsAccountId: agreement.aws_account_id ?? '',
    },
    saasDocumentation: {
      contractEffectiveDate: privateOfferDateToYmd(agreement.start_date),
      contractExpirationDate: privateOfferDateToYmd(agreement.end_date),
      currency: agreement.currency ?? '',
      customerSoftwareValue:
        tcv != null && Number.isFinite(tcv) ? Math.round(tcv) : null,
      procurementType: agreement.procurement_type ?? '',
    },
  }
}

const loadAwsMarketplaceOffersFromOpportunity = async (
  dispatch: AppDispatch,
  partnerId: string,
  referralObject: Record<string, unknown>
): Promise<string[]> => {
  const aceOpportunityId =
    referralObject.Labra__APN_CRM_Unique_Identifier__c as string | undefined

  if (!partnerId || !aceOpportunityId || !aceOpportunityId.startsWith('O')) {
    return []
  }

  try {
    const { data } = await fetchAwsOpportunity(partnerId, aceOpportunityId)
    const response = data as {
      RelatedEntityIdentifiers?: { AwsMarketplaceOffers?: string[] }
      related_entity_identifiers?: { aws_marketplace_offers?: string[] }
    }
    const awsMarketplaceOffers =
      response.RelatedEntityIdentifiers?.AwsMarketplaceOffers ??
      response.related_entity_identifiers?.aws_marketplace_offers ??
      []

    await dispatch(setAwsMarketplaceOffers(awsMarketplaceOffers))
    return awsMarketplaceOffers
  } catch {
    // Optional background enrichment — failures must not block referral UI.
    return []
  }
}

export const getOffersValidations =
  (referralId: string, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(
      startLoading(LoadingTypes.FETCHING_LINKED_PRIVATE_OFFER_VALIDATIONS)
    )
    try {
      const { data } = await fetchPrivateOffersValidation(referralId, productId)
      if (!data?.DetailsDocument) {
        throw new Error('Invalid private offer response')
      }
      const transformedData = {
        offerId: data.DetailsDocument.Id,
        offerName: data.DetailsDocument.Name,
        productId: data.DetailsDocument.ProductId,
      }

      await dispatch(setOffersData(transformedData))
      return data
    } catch (e: unknown) {
      const error = e as AxiosError<APIReferralError>
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return null
    } finally {
      dispatch(
        stopLoading(LoadingTypes.FETCHING_LINKED_PRIVATE_OFFER_VALIDATIONS)
      )
    }
  }

export const getReferral =
  (
    referralId: string,
    partnerType: PartnerType,
    supportMultiCloudForHubspot?: boolean
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.COSELL_FETCH_REFERRAL))
    try {
      let referralData
      let enginePartnerId = ''
      const isHubspotContextFound = isHubSpotContext()
      const pathname =
        typeof window !== 'undefined' && window.location?.pathname
          ? window.location.pathname
          : ''

      if (isHubspotContextFound && !supportMultiCloudForHubspot) {
        // Use CRM Service API endpoint
        const { data } = await fetchReferral(referralId)
        referralData = data
      } else {
        // Use AWS Engine Service API endpoint
        const state = getState()
        const partnerId =
          isHubspotContextFound && supportMultiCloudForHubspot
            ? resolveHubspotReferralPartnerId(state, pathname, partnerType)
            : getTenantPartnerIdFromState(state, partnerType) || ''

        if (!partnerId || isEmpty(partnerId)) {
          throw new Error('PartnerId is required to fetch referral')
        }

        const { data } = await fetchReferralAPI(partnerId, referralId)

        // Transform Salesforce response structure to match expected format
        // Salesforce returns: { labra_referral: {...}, id, crm_id, ... }
        // Expected format: { referral_object: {...}, referral_metadata: {...} }
        const { labra_referral, ...rest } = data
        enginePartnerId = data.partner_id || ''
        const metadataPartnerId =
          isHubspotContextFound && supportMultiCloudForHubspot
            ? partnerId || enginePartnerId
            : enginePartnerId
        referralData = {
          referral_object: labra_referral || {},
          referral_metadata: {
            referral_id: data.id || referralId,
            referral_type:
              data.object_type === 'lead'
                ? 'referral_lead'
                : 'referral_opportunity',
            referral_status: data.form_status || '',
            crm_id: data.crm_id,
            partner_id: metadataPartnerId,
            crmPrimaryKeyValue: data.id || referralId,
            ...rest,
          },
        }
      }

      const referralType = getReferralType(referralData)
      const actions = getReferralActions(referralType)

      if (!referralData?.referral_object) {
        throw new Error('referral_object is missing from referral data')
      }

      const referralObject = {
        ...referralData.referral_object,
        Labra__Referred_By__c: getReferredBy(
          referralData.referral_object.Labra__Referred_By__c
        ),
      }

      const transformedData = actions.transform(referralObject as any) as any

      await dispatch(actions.setReferralCreationData(transformedData))

      // Get partnerId for fetching sync records (HubSpot multi-cloud: path cloud account id)
      const partnerIdForSync =
        isHubSpotContext() && supportMultiCloudForHubspot
          ? resolveHubspotReferralPartnerId(
              getState(),
              pathname,
              partnerType
            ) ||
            referralData.referral_metadata?.partner_id ||
            ''
          : referralData.referral_metadata?.partner_id ||
            getTenantPartnerIdFromState(getState(), partnerType) ||
            ''
      let referralSyncData: SyncRecord[] | null = null
      try {
        if (partnerIdForSync) {
          const isHubspotContext = isHubSpotContext()

          if (isHubspotContext && !supportMultiCloudForHubspot) {
            // HubSpot: backend already returns a consumable shape — just camelize and pass through
            const syncResponse = await fetchReferralSyncRecords(referralId)
            const responseData = syncResponse?.data ?? syncResponse ?? null
            referralSyncData = responseData
              ? (camelize(responseData) as any)
              : []
          } else {
            const syncResponse = await fetchPartnerObject(
              partnerIdForSync,
              referralId,
              'syncs',
              'opportunity'
            )
            const responseData = syncResponse.data || {}
            const camelizedSyncResponse = camelize(responseData) as Record<
              string,
              unknown
            >
            referralSyncData = mapPartnerObjectSyncsToSyncRecords(
              extractPartnerObjectSyncs(
                responseData as Record<string, unknown>
              ),
              String(camelizedSyncResponse.referralId ?? referralId)
            )
          }
        }
      } catch (syncError) {
        console.warn(
          '[getReferral] Failed to fetch referral sync records (non-critical):',
          syncError
        )
        // Continue without sync records - this is not critical for rendering
      }

      const camelizedMetadata = camelize(referralData.referral_metadata) as any
      const parentObjectId = (
        camelizedMetadata.parentObjectId ||
        referralData.referral_metadata?.parent_object_id ||
        ''
      )
        .toString()
        .trim()
      await dispatch(
        actions.setReferralDetails({
          referralMetadata: {
            ...camelizedMetadata,
            referralId: camelizedMetadata.referralId || referralId, // Ensure referralId is set
            ...(parentObjectId ? { parentObjectId } : {}),
          },
          referralObject: referralObject,
          referralSyncs: referralSyncData || [],
        })
      )

      if (referralType === 'opportunity') {
        const partnerIdForAwsOpportunity = isHubspotContextFound
          ? resolveHubspotReferralPartnerId(
              getState(),
              pathname,
              partnerType
            ) || partnerIdForSync
          : partnerIdForSync

        void loadAwsMarketplaceOffersFromOpportunity(
          dispatch,
          partnerIdForAwsOpportunity,
          referralObject
        )
      }

      // Return the referral payload so callers can await dispatch(getReferral(...))
      return {
        referralMetadata: {
          ...camelizedMetadata,
          referralId: camelizedMetadata.referralId || referralId,
          ...(parentObjectId ? { parentObjectId } : {}),
        },
        referralObject: referralObject,
        referralSyncs: referralSyncData || [],
      }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      dispatch(stopLoading(LoadingTypes.COSELL_FETCH_REFERRAL))
    }
  }

export const deleteDraftReferral =
  (referralId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.COSELL_DELETE_REFERRAL))

    try {
      await deleteReferral(referralId)

      return {
        sucess: true,
      }
    } catch (e: any) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return {
        sucess: false,
        error: error,
      }
    } finally {
      dispatch(stopLoading(LoadingTypes.COSELL_DELETE_REFERRAL))
    }
  }

export const setLabraReferralStatusHistory = (
  statusHistory: LabraReferralStatusHistory[]
) => ({
  type: ReferralFormActions.SET_LABRA_REFERRAL_STATUS_HISTORY,
  payload: statusHistory,
})

const statusToAction: Record<string, string> = {
  'Received': 'REFERRAL_RECEIVED_FROM_AWS',
  Draft: 'REFERRAL_DRAFT',
  Submitted: 'REFERRAL_SUBMITTED',
  Accepted: 'REFERRAL_ACCEPTED',
  Approved: 'REFERRAL_APPROVED',
  Rejected: 'REFERRAL_REJECTED',
  Launched: 'REFERRAL_LAUNCHED',
  'Closed Lost': 'REFERRAL_CLOSED_LOST',
}

export const normalizeLabraReferralStatusHistory = (
  statusHistory: Array<Record<string, string | undefined>>
): LabraReferralStatusHistory[] =>
  statusHistory.map(entry => ({
    action: entry.action || statusToAction[entry.status || ''] || '',
    created_at: entry.created_at || entry.updated_at,
  }))

export const fetchLabraReferralStatusHistory =
  (partnerId: string, referralId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(
      startLoading(LoadingTypes.COSELL_FETCH_LABRA_REFERRAL_STATUS_HISTORY)
    )

    try {
      const { data } = await apiFetchLabraReferralStatusHistory(
        partnerId,
        referralId
      )
      const statusHistory = Array.isArray(data?.status_history)
        ? normalizeLabraReferralStatusHistory(data.status_history)
        : []

      dispatch(setLabraReferralStatusHistory(statusHistory))
    } catch (e: any) {
      dispatch(setLabraReferralStatusHistory([]))
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            e.response as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      dispatch(
        stopLoading(LoadingTypes.COSELL_FETCH_LABRA_REFERRAL_STATUS_HISTORY)
      )
    }
  }

export const setValidationErrors =
  (
    errors: FormikErrors<ReferralOppSections>,
    referralType: CosellReferralType
  ) =>
  (dispatch: AppDispatch) => {
    const setErrorsAction =
      referralType === 'opportunity'
        ? setFormFieldErrors
        : setLeadFormFieldErrors
    const referralErrors = formikErrorsToReferral(errors)
    dispatch(setErrorsAction(referralErrors as any))
  }

export const initializeHubspotReferralCloneForm =
  (sourceReferralId: string, supportMultiCloudForHubspot?: boolean) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.COSELL_FETCH_REFERRAL))
    try {
      const state = getState()
      const pathname =
        typeof window !== 'undefined' && window.location?.pathname
          ? window.location.pathname
          : ''
      const partnerType = isAdminRole(state.userProfile.userProfile)
        ? PartnerType.Admin
        : PartnerType.User
      const partnerId = resolveHubspotReferralPartnerId(
        state,
        pathname,
        partnerType
      )
      if (!partnerId || isEmpty(partnerId)) {
        throw new Error('PartnerId is required to clone referral')
      }

      const { data } = await fetchReferralAPI(partnerId, sourceReferralId)
      const sourceLabraReferral =
        (data.labra_referral as Record<string, unknown> | undefined) ?? {}
      const clonedReferralObject = prepareLabraReferralObjectForClone(
        sourceLabraReferral,
        String(sourceLabraReferral.Name ?? '')
      )
      const referralObject = {
        ...clonedReferralObject,
        Labra__Referred_By__c: getReferredBy(
          String(clonedReferralObject.Labra__Referred_By__c ?? '')
        ),
      }

      const referralType =
        data.object_type === 'lead' ? 'referral_lead' : 'referral_opportunity'
      const actions = getReferralActions(
        referralType === 'referral_lead' ? 'lead' : 'opportunity'
      )
      const transformedData = actions.transform(referralObject as any) as any
      await dispatch(actions.setReferralCreationData(transformedData))

      const existingMetadata =
        state.referralFormCreation.referral?.referralMetadata ||
        camelize(
          state.customForm.hubspotForm.customData?.referralMetadata ?? {}
        )

      await dispatch(
        actions.setReferralDetails({
          referralMetadata: {
            ...existingMetadata,
            referralType,
            referralStatus: 'draft',
            partnerId:
              (supportMultiCloudForHubspot ? partnerId : undefined) ||
              existingMetadata?.partnerId ||
              data.partner_id,
            referralId: undefined,
          },
          referralObject,
          form_status: 'draft',
        })
      )
      return { success: true }
    } catch (e: unknown) {
      const error = e as AxiosError<APIReferralError>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error.response as unknown as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
      return { success: false }
    } finally {
      // Always clear clone loading after success or after the catch block shows
      // the error alert; the hook uses the returned failure to move its machine
      // out of loading.
      dispatch(stopLoading(LoadingTypes.COSELL_FETCH_REFERRAL))
    }
  }
